import { render } from "./DepositModal.vue?vue&type=template&id=3b545c8c&scoped=true"
import script from "./DepositModal.vue?vue&type=script&lang=js"
export * from "./DepositModal.vue?vue&type=script&lang=js"

import "./DepositModal.vue?vue&type=style&index=0&id=3b545c8c&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/weapsmithing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b545c8c"]])

export default __exports__